import axios from 'axios';
import {isOpenInEditor} from "@/plugins/Helpers";
import * as Sentry from "@sentry/vue";

axios.defaults.maxRedirects = 2;
axios.defaults.withCredentials = true;

const token: HTMLMetaElement | null = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else if (!isOpenInEditor()) {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
    Sentry.captureMessage('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token', 'error');
}
export default axios;
